import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextToSpeach: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-to-speach"} maskId="square-filled-radius-0-stroke-1-IconTextToSpeach"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H13V6H12V4H8.5V12H10.5V13H5.5V12H7.5V4H4V6H3V3ZM15 7V21H14V7H15ZM18 10V18H17V10H18ZM21 12V16H20V12H21ZM12 14V18H11V14H12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextToSpeach;
